const isWeb = true;
const isMRN = false;
import { navigateTo } from '@max/meituan-uni-navigate';
import { isMeituanAppOrWebview } from '@nibfe/mkt-env-api';
/**
 * 跳转到详情页
 * @param url 跳转链接
 */
export function navigationToDetail(url) {
    if (!url) {
        console.warn('[navigationToDetail] url is empty');
        return;
    }
    try {
        if (isMRN) {
            // MRN环境使用原生跳转
            const { NavigationModule } = require('@mrn/react-native');
            NavigationModule.openURL(url);
        }
        else if (isWeb) {
            // Web环境直接跳转
            window.location.href = url;
        }
        else {
            // 其他环境使用通用跳转
            // console.log('[navigationToDetail] jump to:', url);
        }
    }
    catch (error) {
        console.error('[navigationToDetail] error:', error);
    }
}
const convertLinkToAppMiddleOpenLink = (url) => {
    return `https://m.dianping.com/awp/hfe/block-page/call-native/meituan.html?url=${encodeURIComponent(url)}`;
};
/**
 * 跳转
 * @param url 跳链
 */
export function navigateToPage(url) {
    // console.log('navigateToPage', url);
    if (isMeituanAppOrWebview()) {
        if (true) {
            url = encodeURI(url);
        }
        navigateTo({
            url,
            _web: {
                miniProgramNative: true
            }
        });
    }
    else {
        navigateTo({
            url: convertLinkToAppMiddleOpenLink(url),
            _web: {
                miniProgramNative: true
            }
        });
    }
}
